import { Component, OnChanges, Output, Input, EventEmitter, OnInit } from '@angular/core';

@Component( {
    moduleId: module.id,
    selector: 'mainButtonBar',
    templateUrl: 'buttonbar.component.html',
    styleUrls: ['buttonbar.component.css']

})
export class ButtonBarComponent implements OnChanges {

    constructor() {}

    @Input() buttonBarHidden: boolean = true;
    @Input() buttonActivateDisabled: boolean = false;
    @Input() buttonPreviewDisabled: boolean = false;
    @Input() buttonNewDisabled: boolean = false;
    @Input() buttonDuplicateDisabled: boolean = false;
    @Input() buttonSaveDisabled: boolean = false;
    @Input() buttonApproveDisabled: boolean = false;
    @Input() buttonHistoryDisabled: boolean = false;
    @Input() buttonDeleteDisabled: boolean = false;

    @Input() buttonNewVisible: boolean = false;
    @Input() buttonPreviewVisible: boolean = false;
    @Input() buttonActivateVisible: boolean = false;
    @Input() buttonDuplicateVisible: boolean = false;
    @Input() buttonSaveVisible: boolean = false;
    @Input() buttonApproveVisible: boolean = false;
    @Input() buttonHistoryVisible: boolean = false;
    @Input() buttonDeleteVisible: boolean = false;

    btnBarHidden: boolean = true;
    btnDuplicateDisabled: boolean = true;
    btnActivateDisabled: boolean = false;
    btnNewDisabled: boolean = false;
    btnPreviewDisabled: boolean = false;
    btnSaveDisabled: boolean = false;
    btnApproveDisabled: boolean = false;
    btnHistoryDisabled: boolean = false;
    btnDeleteDisabled: boolean = false;

    btnDuplicateVisible: boolean = true;
    btnActivateVisible: boolean = false;
    btnNewVisible: boolean = false;
    btnPreviewVisible: boolean = false;
    btnSaveVisible: boolean = false;
    btnApproveVisible: boolean = false;
    btnHistoryVisible: boolean = false;
    btnDeleteVisible: boolean = false;

    @Output() outputExecuteCommand: EventEmitter<string> = new EventEmitter<string>();

    ngOnInit(): void {
        this.btnBarHidden= this.buttonBarHidden;
        this.btnActivateDisabled = this.buttonActivateDisabled;
        this.btnNewDisabled = this.buttonNewDisabled;
        this.btnPreviewDisabled = this.buttonPreviewDisabled;
        this.btnSaveDisabled = this.buttonSaveDisabled;
        this.btnApproveDisabled = this.buttonApproveDisabled;
        this.btnHistoryDisabled = this.buttonHistoryDisabled;
        this.btnDeleteDisabled = this.buttonDeleteDisabled;
        this.btnDuplicateDisabled = this.buttonDuplicateDisabled;

        this.btnDuplicateVisible = this.buttonDuplicateVisible;
        this.btnActivateVisible = this.buttonActivateVisible;
        this.btnNewVisible = this.buttonNewVisible;
        this.btnPreviewVisible = this.buttonPreviewVisible;
        this.btnSaveVisible = this.buttonSaveVisible;
        this.btnApproveVisible = this.buttonApproveVisible;
        this.btnHistoryVisible =  this.buttonHistoryVisible; //History button will most likely not be used anywere
        this.btnDeleteVisible = this.buttonDeleteVisible;

    }

    ngOnChanges() {
        this.btnBarHidden = this.buttonBarHidden;
        this.btnActivateDisabled = this.buttonActivateDisabled;
        this.btnNewDisabled = this.buttonNewDisabled;
        this.btnPreviewDisabled = this.buttonPreviewDisabled;
        this.btnSaveDisabled = this.buttonSaveDisabled;
        this.btnApproveDisabled = this.buttonApproveDisabled;
        this.btnHistoryDisabled = this.buttonHistoryDisabled;
        this.btnDeleteDisabled = this.buttonDeleteDisabled;
        this.btnDuplicateDisabled = this.buttonDuplicateDisabled;

        this.btnDuplicateVisible = this.buttonDuplicateVisible;
        this.btnActivateVisible = this.buttonActivateVisible;
        this.btnNewVisible = this.buttonNewVisible;
        this.btnPreviewVisible = this.buttonPreviewVisible;
        this.btnSaveVisible = this.buttonSaveVisible;
        this.btnApproveVisible = this.buttonApproveVisible;
        this.btnHistoryVisible = this.buttonHistoryVisible;//History button will most likely not be used anywere
        this.btnDeleteVisible = this.buttonDeleteVisible;
    }

    execute(action:string) {
        this.outputExecuteCommand.emit( action );

    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/guicomponents/buttonbar/buttonbar.component.ts